import React from "react";
import {useNavigate} from "react-router-dom";
import settingsImg from "../../images/settings.svg";
import "./SettingsButton.css";

function SettingsButton() {
  const navigate = useNavigate();
  return (
    <button className="settings-button" onClick={() => navigate("/settings")}>
      <img src={settingsImg} alt="" />
    </button>
  );
}

export default SettingsButton;
